import React, { useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import "../../tutor_v2/TutorDashboardV2.css";

const NAV_ITEMS = [
  { label: "Student Progress", to: "/tutor/student-progress" },
  { label: "Enrollment Requests", to: "/admin/enrollments" },
  { label: "Users", to: "/admin/users" },
  { label: "Cohorts", to: "/admin/cohorts" },
  { label: "Audit Log", to: "/admin/audit-log" },
];

export default function AdminShell({ title, subtitle, children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const backTarget = useMemo(() => {
    const studentId = String(localStorage.getItem("student_id") || "").trim().toUpperCase();
    return studentId ? `/student/dashboard/${encodeURIComponent(studentId)}` : "/";
  }, []);
  return (
    <div className="td-wrap">
      <section className="td-card td-header reveal" style={{ "--delay": ".04s" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <button
              type="button"
              onClick={() => navigate(backTarget)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                color: "#fff",
                textDecoration: "none",
                fontSize: 13,
                fontWeight: 700,
                padding: "8px 12px",
                borderRadius: 999,
                border: "1px solid rgba(255,255,255,.12)",
                background: "rgba(255,255,255,.03)",
              }}
            >
              ← Back to Dashboard
            </button>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 16, alignItems: "flex-end" }}>
            <div>
              <h1 className="td-title">{title}</h1>
              <p className="td-sub">{subtitle}</p>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {NAV_ITEMS.map((item) => {
                const active = location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    style={{
                      padding: "9px 12px",
                      borderRadius: 999,
                      border: "1px solid rgba(255,255,255,.12)",
                      background: active ? "rgba(201,165,106,.18)" : "rgba(255,255,255,.03)",
                      color: "#fff",
                      textDecoration: "none",
                      fontWeight: 700,
                      fontSize: 13,
                    }}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {children}
    </div>
  );
}
